/**
 * Builds a URL for viewing a prospect while preserving current filters
 */
export const buildProspectLink = (
  prospectId: string,
  currentSearchParams: URLSearchParams
): string => {
  const params = new URLSearchParams(currentSearchParams);
  params.set('prospectId', prospectId);
  return `/players?${params.toString()}`;
};
